import { POSTWithAuth } from './Index'

import { UpdateProfileRequest, UpdateProfileResponse } from '../interfaces'

export async function UpdateProfile(
  user: string,
  request: UpdateProfileRequest
): Promise<UpdateProfileResponse> {
  return await POSTWithAuth<UpdateProfileRequest, UpdateProfileResponse>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/users/${user}/update`,
    request
  )
}
